import { Profile } from '@/types/auth';

/**
 * Determines if a user needs to complete their profile setup
 * Uses a hierarchy of checks for reliable detection:
 * 1. Primary: has_completed_onboarding flag
 * 2. Fallback: is_username_customized flag + username pattern
 */
export const needsProfileCompletion = (profile: Profile | null): boolean => {
  if (!profile) return false;

  // Primary check: if onboarding completion flag is explicitly set
  if (profile.has_completed_onboarding === true) {
    return false;
  }

  // If onboarding flag is false, definitely needs completion
  if (profile.has_completed_onboarding === false) {
    return true;
  }

  // Fallback for users without the onboarding flag (backward compatibility)
  // Check if username is customized AND not temporary
  if (profile.is_username_customized === true && !profile.username?.startsWith('user_')) {
    return false;
  }

  // If username starts with 'user_', needs completion
  if (profile.username?.startsWith('user_')) {
    return true;
  }

  // Default to not needing completion for other cases
  return false;
};

/**
 * Determines if a username is temporary (auto-generated)
 */
export const isTemporaryUsername = (username?: string): boolean => {
  return username?.startsWith('user_') || username === 'anonymous' || false;
};